import {
  EValue,
  ICompilationTypeTermFieldSchema,
} from '../../repositories/newbuilding-promos/entities/json_query/CompilationTypeTermFieldSchema';
import { ECompilationType, IJsonQueryCompilationType } from '../../types/jsonQuery/compilationType';
import { EJsonQueryType } from '../../types/jsonQuery/term';

const COMPILATION_TYPE_MAP = new Map([
  [EValue.LastChanceDiscount, ECompilationType.LastChanceDiscount],
  [EValue.TopPromos, ECompilationType.TopPromos],
]);

export function mapJsonQueryCompilationType(
  term?: ICompilationTypeTermFieldSchema | null,
): IJsonQueryCompilationType | null {
  if (!term) {
    return null;
  }

  return {
    type: EJsonQueryType.Term,
    value: COMPILATION_TYPE_MAP.get(term.value) as ECompilationType,
  };
}
